import React from 'react'
import {
  shape, string, bool, array, object,
} from 'prop-types'
import Collapsible from 'react-collapsible'

import NewLogoSmall from 'images/cg_icon_rgb_small.svg'

import i18n from 'Pods/Shared/I18n'
import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'
import Icon from 'Pods/Shared/Icon/Icon'
import ContactModal from 'Pods/Shared/ContactModal'
import UserSidebarAction from 'Pods/Shared/UserSidebarAction'
import { LessThanBreakpoint } from 'Utils/GetBreakpoint'

import UserSidebarSocialMedias from './Components/UserSidebarSocialMedias'
import UserSidebarUserData from './Components/UserSidebarUserData'
import UserSidebarPills from './Components/UserSidebarPills'

class UserSidebar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      contactModalIsOpen: false,
      isResponsive: false,
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.updateSidebar = this.updateSidebar.bind(this)
  }

  componentDidMount() {
    this.updateSidebar()

    window.addEventListener('resize', this.updateSidebar)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSidebar)
  }

  updateSidebar() {
    this.setState({ isResponsive: LessThanBreakpoint('md') })
  }

  toggleModal() {
    const { contactModalIsOpen } = this.state
    this.setState({ contactModalIsOpen: !contactModalIsOpen })
  }

  cleanDescription(description) {
    const regex = /\bhttps?:\/\/(?:www\.)?turbosquid\.com(?:\/[^\s]*)?\b/gm

    return description.replace(regex, '')
  }

  render() {
    const {
      userInfo,
      userRatings,
      userActions,
      messagingForbidden,
    } = this.props

    const {
      isResponsive,
      contactModalIsOpen,
    } = this.state

    const renderTrigger = <h4 className="heading-16 text-bold l-inner">{i18n.t('profilePage.about', { ns: 'rails', lng: this.props.locale })}</h4>

    return (
      <aside className="card">
        {!!userInfo.donationEnabled && !userInfo.noUkraineBadge && (
          <div className="content-box__discount-badge ukranian-badge__donation">
            {userInfo.donationRate}% for Ukraine
          </div>
        )}
        <div className="user-data">
          <section className="user-data__section user-data__section--top l-inner u-text-center">
            <div className="user-data__avatar-wrapper">
              <UserAvatar userName={userInfo.username} size="huge" img={userInfo.avatar} />
            </div>
            <h1 className="heading-20 text-bold">{userInfo.fullName || userInfo.username}</h1>
            {userInfo.isAdmin && (
              <p className="user-data__is-admin">
                <img
                  src={NewLogoSmall}
                  alt="CGTrader - 3D Models / 3D Designers"
                  width="15"
                  height="15"
                  loading="lazy"
                />
                Admin
              </p>
            )}
            {userInfo.occupation && <p className="text-extra-small user-data__occupation">{userInfo.occupation}</p>}
            {userInfo.location && (
              <p className="user-data__location">
                <span>
                  <Icon type={['far', 'map-marker-alt']} />
                  {userInfo.location}
                </span>
              </p>
            )}
            {contactModalIsOpen && (
              <ContactModal
                modalIsOpen
                closeModal={this.toggleModal}
                authorUsername={userInfo.username}
                conversationType="personal"
                messagingForbidden={messagingForbidden}
              />
            )}
            {userActions && (
              <div className="user-data__actions">
                {Object.keys(userActions).map((action) => (
                  <UserSidebarAction
                    key={`action-${userActions[action].title}`}
                    action={userActions[action]}
                    openModal={this.toggleModal}
                    id={userInfo.username}
                  />
                ))}
              </div>
            )}
          </section>

          <UserSidebarSocialMedias props={userInfo} />

          <UserSidebarUserData
            userInfo={userInfo}
            userRatings={userRatings}
            isResponsive={isResponsive}
            newRoyaltyUi={this.props.newRoyaltyUi}
            locale={this.props.locale}
          />

          {userInfo.description && (
            <section className="user-data__section">
              <Collapsible
                className="Collapsible--transparent"
                openedClassName="Collapsible--transparent is-opened"
                overflowWhenOpen="visible"
                trigger={renderTrigger}
                transitionTime={300}
                open={!isResponsive}
              >
                <p><small>{this.cleanDescription(userInfo.description)}</small></p>
              </Collapsible>
            </section>
          )}

          {userInfo.skills.length > 0 && (
            <UserSidebarPills
              items={userInfo.skills}
              keyPrefix="skill"
              title={i18n.t('profilePage.skill', { ns: 'rails', lng: this.props.locale })}
            />
          )}
          {userInfo.software.length > 0 && (
            <UserSidebarPills
              items={userInfo.software}
              keyPrefix="software"
              title={i18n.t('profilePage.software', { ns: 'rails', lng: this.props.locale })}
            />
          )}
        </div>
      </aside>
    )
  }
}

UserSidebar.propTypes = {
  userInfo: shape({
    username: string.isRequired,
    allowPrivateJobRequests: bool.isRequired,
    fullName: string,
    occupation: string,
    location: string,
    description: string,
    avatar: string,
    skills: array,
    software: array,
    rankDetails: object.isRequired,
    isAdmin: bool.isRequired,
  }),
  userActions: object.isRequired,
  userRatings: object,
  messagingForbidden: bool,
}

UserSidebar.defaultProps = {
  userInfo: {
    fullName: '',
    occupation: '',
    location: '',
    description: '',
    avatar: '',
    skills: [],
    software: [],
  },
  userRatings: {},
  messagingForbidden: false,
}

export default UserSidebar
